/**
 * Urge-style collection: layout switcher, filter drawer, sort, infinite scroll
 * Filters use native GET form + Shopify storefront filtering URL params.
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initLayoutSwitcher(root) {
    var container = root;
    qsa('.urge-collection__layout-btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        ['product-grid-basic', 'product-grid-6', 'product-grid-12'].forEach(function (cls) {
          if (cls !== btn.getAttribute('data-layout')) container.classList.remove(cls);
        });
        container.classList.add(btn.getAttribute('data-layout'));
        qsa('.urge-collection__layout-btn', root).forEach(function (b) {
          b.classList.remove('is-active', 'active');
        });
        btn.classList.add('is-active', 'active');
      });
    });

    if (window.innerWidth < 768 && container.classList.contains('product-grid-basic')) {
      container.classList.remove('product-grid-basic');
      container.classList.add('product-grid-6');
      var one = qs('.urge-collection__layout-btn[data-layout="product-grid-basic"]', root);
      var two = qs('.urge-collection__layout-btn[data-layout="product-grid-6"]', root);
      if (one) one.classList.remove('is-active', 'active');
      if (two) two.classList.add('is-active', 'active');
    }
  }

  function initDrawer(root) {
    var drawer = qs('[data-collection-drawer]', root);
    if (!drawer) return;
    var openBtn = qs('[data-collection-filters-open]', root);
    var closeTargets = qsa('[data-collection-drawer-close]', drawer);

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closeTargets.forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initSort(root) {
    var form = qs('[data-collection-filters-form]', root);
    var sortInput = form && qs('[data-sort-input]', form);
    if (!sortInput) return;

    // Sort lives inside the filter drawer: pick an option, then RESULTS applies it with the filters.
    qsa('[data-sort-value]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa('[data-sort-value]', form).forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        sortInput.value = btn.getAttribute('data-sort-value') || '';
        sortInput.disabled = !sortInput.value;
      });
    });
  }

  function initFilters(root) {
    var form = qs('[data-collection-filters-form]', root);
    if (!form) return;

    // Toggle visual active state on checkbox labels
    form.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'checkbox') return;
      var label = input.closest('.urge-collection__filter-value');
      if (!label) return;
      if (input.checked) label.classList.add('is-active');
      else label.classList.remove('is-active');
    });

    // Native GET submit — strip empty price fields so Shopify ignores them
    form.addEventListener('submit', function () {
      qsa('input[data-price-input]', form).forEach(function (input) {
        if (input.value === '') input.disabled = true;
      });
    });
  }

  /**
   * Fast infinite scroll via IntersectionObserver.
   * Prefetches the next page ~1200px before the sentinel enters view.
   * Collection page only (this file is loaded from sections/collection.liquid).
   */
  function initInfiniteScroll(root) {
    var grid = qs('#product-grid', root);
    var sentinel = qs('[data-collection-scroll-sentinel]', root);
    if (!grid || !sentinel || typeof IntersectionObserver === 'undefined') return;

    var nextUrl = grid.getAttribute('data-next-url') || '';
    var loading = false;
    var done = !nextUrl;
    var controller = null;

    function setLoading(state) {
      loading = state;
      sentinel.classList.toggle('is-loading', state);
      sentinel.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    function finish() {
      done = true;
      nextUrl = '';
      grid.removeAttribute('data-next-url');
      sentinel.hidden = true;
      if (observer) observer.disconnect();
    }

    function appendPage(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextGrid = doc.querySelector('#product-grid');
      if (!nextGrid) {
        finish();
        return;
      }

      var items = Array.prototype.slice.call(nextGrid.children).filter(function (el) {
        return el.nodeType === 1 && (el.classList.contains('grid__item') || el.tagName === 'LI');
      });
      if (!items.length) {
        finish();
        return;
      }

      var frag = document.createDocumentFragment();
      items.forEach(function (item) {
        frag.appendChild(item);
      });
      grid.appendChild(frag);

      var newNext = nextGrid.getAttribute('data-next-url') || '';
      if (newNext) {
        nextUrl = newNext;
        grid.setAttribute('data-next-url', newNext);
      } else {
        finish();
      }
    }

    function loadNext() {
      if (loading || done || !nextUrl) return;
      setLoading(true);

      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      fetch(nextUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          appendPage(html);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          console.warn('Collection infinite scroll failed', err);
        })
        .finally(function () {
          setLoading(false);
          if (!done && nextUrl) observer.observe(sentinel);
        });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            observer.unobserve(sentinel);
            loadNext();
            break;
          }
        }
      },
      {
        root: null,
        rootMargin: '1200px 0px',
        threshold: 0
      }
    );

    if (!done) observer.observe(sentinel);
  }

  function init(root) {
    if (!root || root.getAttribute('data-collection-ready')) return;
    root.setAttribute('data-collection-ready', '1');
    initLayoutSwitcher(root);
    initDrawer(root);
    initSort(root);
    initFilters(root);
    initInfiniteScroll(root);
  }

  function boot() {
    qsa('[data-urge-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
